import React from 'react';
import { useHistory } from 'react-router-dom';
import { Image, Modal } from '@asigna/kit';
import cx from 'classnames';
import { ConnectWalletModal, getWalletConenctors } from 'components';
import useAddress from 'hooks/use-address';
import useNetwork from 'hooks/use-network';
import { NETWORK } from 'types/enums';
import { shortenAddress } from 'utils/helper';
import { getStorageKeysForNetwork } from 'utils/LocalstorageUtils';

import { arrowIcon, stacksIcon } from './util/images';
import { useConnectWalletButton } from './util/useConnectWalletButton';
import { CurrentNetworkCard, NetworkCard, WrongNetworkPopup } from './components';

export const ConnectWalletButton: React.FC = () => {
  const walletAccount = useAddress();

  const [network, , setNetwork] = useNetwork();
  const history = useHistory();

  const {
    isDropdownOpen,
    setDropdownOpen,
    connectModalOpen,
    setConnectModalOpen,
    networkOptions,
    handleLogout,
  } = useConnectWalletButton();

  const WalletConnectors = getWalletConenctors();

  const storedProvider = localStorage.getItem(getStorageKeysForNetwork().walletType) || '';
  const WalletIcon =
    WalletConnectors.find(
      (connector) => connector.title.toUpperCase() === storedProvider.toUpperCase()
    )?.logo || stacksIcon;

  return (
    <div className={cx('relative', walletAccount ? 'w-[140px]' : 'w-[110px]')}>
      <button
        className={cx(
          'flex items-center gap-4 border rounded-[8px] border-[.5px] border-black-4 bg-white-3 h-40 px-8 py-8 min-w-100 ml-auto hover:bg-white-10',
          walletAccount ? 'w-[140px]' : 'w-[110px]'
        )}
        onClick={(e) => {
          e.stopPropagation();
          setDropdownOpen((previousState) => !previousState);
        }}
      >
        <div className="relative flex">
          <Image src={WalletIcon} size={20} className="rounded-[10px]" />
          {network === 'testnet' && (
            <div className="absolute bg-success w-[10px] h-[10px] rounded-[50%] bottom-[-2px] right-[-2px] border-2 border-[#18181A]" />
          )}
        </div>

        <p className="text-r12">{walletAccount ? shortenAddress(walletAccount || '') : 'Stacks'}</p>
        <Image
          src={arrowIcon}
          size={{ w: 13, h: 8 }}
          className={cx('ml-auto transition-transform', isDropdownOpen ? 'rotate-0' : 'rotate-180')}
        />
      </button>
      {isDropdownOpen && (
        <div
          className="fixed inset-0 z-10"
          onClick={(e) => {
            e.stopPropagation();
            setDropdownOpen((previousState) => !previousState);
          }}
        />
      )}
      <div
        className={cx(
          'fixed sm:absolute w-[225px] right-0 py-8 bg-black-1 rounded-[12px] border border-[#34353B] shadow-2xl cursor-pointer transition-transform 0.3s ease origin-top-right mt-4',
          isDropdownOpen ? 'scale-100 opacity-100 z-20 ' : 'scale-0 opacity-0'
        )}
      >
        {networkOptions
          .filter((network) => !Boolean(network.link) && !network.testnet)
          .map(({ key, icon, title, soon }) => {
            return key.toUpperCase() === network.toUpperCase() && walletAccount ? (
              <CurrentNetworkCard
                key={key}
                walletAccount={walletAccount || ''}
                title={title}
                icon={icon}
                handleClose={() => setDropdownOpen(false)}
                onLogout={handleLogout}
              />
            ) : (
              <NetworkCard
                key={key}
                title={title}
                icon={icon}
                soon={soon}
                handleClick={() => {
                  setDropdownOpen(false);
                  setNetwork(key as NETWORK);
                  localStorage.setItem('network', key as NETWORK);
                  setConnectModalOpen(false);
                  history.push('/');
                }}
              />
            );
          })}
        <p className="text-m12 text-regular py-8 px-16 uppercase border-t border-white-10 mt-8">
          Testnet
        </p>
        {networkOptions
          .filter((network) => !Boolean(network.link) && network.testnet)
          .map(({ key, icon, title, soon }) => {
            return key.toUpperCase() === network.toUpperCase() && walletAccount ? (
              <CurrentNetworkCard
                key={key}
                walletAccount={walletAccount || ''}
                title={title}
                icon={icon}
                testnet
                handleClose={() => setDropdownOpen(false)}
                onLogout={handleLogout}
              />
            ) : (
              <NetworkCard
                key={key}
                title={title}
                icon={icon}
                soon={soon}
                testnet
                handleClick={() => {
                  setDropdownOpen(false);
                  setNetwork(key as NETWORK);
                  localStorage.setItem('network', key as NETWORK);
                  history.push('/');
                  setConnectModalOpen(false);
                }}
              />
            );
          })}
        <p className="text-m12 text-regular py-8 px-16 uppercase border-t border-white-10 mt-8">
          Other
        </p>
        {networkOptions
          .filter((network) => Boolean(network.link))
          .map(({ key, icon, title, link, soon }) => (
            <NetworkCard
              key={key}
              title={title}
              icon={icon}
              soon={soon}
              link={link}
              handleClick={() => {
                setDropdownOpen(false);
                window.open(link, '_blank');
              }}
            />
          ))}
      </div>

      <WrongNetworkPopup />
      <Modal onClose={() => setConnectModalOpen(false)} isShow={connectModalOpen}>
        <ConnectWalletModal open={connectModalOpen} onClose={() => setConnectModalOpen(false)} />
      </Modal>
    </div>
  );
};
